import { render, staticRenderFns } from "./FilmList.vue?vue&type=template&id=23b39ebc&scoped=true&"
import script from "./FilmList.vue?vue&type=script&lang=ts&"
export * from "./FilmList.vue?vue&type=script&lang=ts&"
import style0 from "./FilmList.vue?vue&type=style&index=0&id=23b39ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b39ebc",
  null
  
)

export default component.exports